import React, { Component } from 'react';

import {API_BASE_URL} from '../../constants'

import axios from 'axios'
import {getToken} from '../../storage'
import {NotificationManager} from 'react-notifications'

class AddUnit extends Component {


  constructor(props) {
    super(props)
    this.addunit = this.addunit.bind(this)

    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleContainerChange= this.handleContainerChange.bind(this)
    this.modifyItemState = this.modifyItemState.bind(this)
    this.getUnit = this.getUnit.bind(this)
    this.deleteUnit = this.deleteUnit.bind(this)
    this.state = {unit: {primary_unit_code:"", primary_unit:'', container_unit:'', container_volume:0, container_unit_plural:''}, showContainerForm:false}
  }

  componentDidMount() {
    if(typeof this.props.match !=="undefined" && typeof this.props.match.params.unit_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Unit " + this.props.match.params.unit_id
      this.getUnit(this.props.match.params.unit_id).then((response)=>{
        if(response.status===200) {
          this.setState({unit: response.data.unit, loading:false})

        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }

    else {
        document.title = "Create Unit"
        this.setState({loading:false})
    }

  }

  getUnit(unit_id) {
    return axios({
      url: '/get_unit/?id='+unit_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  modifyItemState(name, value) {
    let unit = this.state.unit
    unit[name] = value
    this.setState({unit:unit})
  }

  handleContainerChange(e) {
    let value = e.target.value
    this.modifyItemState('container_unit', value)

    if(value.trim().length > 0) {
        this.setState({showContainerForm: true})
    }
    else {
      this.setState({showContainerForm:false})
      this.modifyItemState('container_volume', 0)
    }

    let container_unit_plural = this.state.container_unit_plural
    if(typeof container_unit_plural === "undefined" || container_unit_plural.length <= 0) {
    this.modifyItemState('container_unit_plural', value)
    }

  }

  handleInputChange(e) {
    this.modifyItemState(e.target.name, e.target.value)
  }
  deleteUnit() {

    axios({
      url: '/delete_unit/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.unit
    }).then((response)=> {
      if(response.status === 200) {
          NotificationManager.success("Deleted Unit successfully")
        setTimeout(()=>{
          this.props.history.push("/units/")
        }, 700)
      }
    }).catch((err)=> {
      console.log(err);
    })
  }
  addunit(e) {
    this.setState({error_response_data: undefined})
    e.preventDefault()

    let apiurl
    if(this.state.mode ==="edit") {
      apiurl  = "/update_unit/"
    }
    else {
      apiurl  = "/create_new_unit/"
    }

    axios({
      baseURL: API_BASE_URL,
      url:apiurl,
      method:"POST",
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data:this.state.unit
    }).then((response)=>{

      this.setState({unit:response.data.unit, submitting:false})
      if(typeof this.props.onAddCallback !== "undefined") {
      this.props.onAddCallback(response.data.unit)
      }
      else {

        if(this.state.mode==="edit") {
          NotificationManager.success("Updated Unit successfully")
        }
        else {
          NotificationManager.success("Created Unit successfully")
        }

        setTimeout(()=>{

          this.props.history.push("/units/")
        }, 700)
      }

    }).catch(err=>{

      if(typeof err.response !== "undefined" && typeof err.response.data !== "undefined") {
        this.setState({error_response_data:err.response.data})
      }

    })
  }


  render() {

    let error_response_data = this.state.error_response_data
    let errors
    let primary_unit_error, container_unit_error, container_volume_error, primary_unit_code
    if(typeof error_response_data !== "undefined") {
      errors = error_response_data.errors
      if(typeof errors.primary_unit !== "undefined" && errors.primary_unit.length > 0) {
        primary_unit_error = errors.primary_unit[0]
      }
      if(typeof errors.container_unit !=="undefined" && errors.container_unit.length>0) {
        container_unit_error = errors.container_unit[0]
      }
      if(typeof errors.container_volume !=="undefined" && errors.container_volume.length>0) {
        container_volume_error = errors.container_volume[0]
      }
      if(typeof errors.primary_unit_code !=="undefined" && errors.primary_unit_code.length>0) {
        primary_unit_code = errors.primary_unit_code[0]
      }

    }


    let unit = this.state.unit
    let containerForm
    if(this.state.showContainerForm || (unit.container_unit && unit.container_unit.length > 0)) {

        containerForm = <div>1 {unit.container_unit} = <input type="number" value={unit.container_volume} name="container_volume" onChange={this.handleInputChange} className="" /> {unit.primary_unit} </div>
    }


    let pageHeader, deleteUnitBtn
    if(this.state.mode === "edit") {
      deleteUnitBtn = <button className="btn btn-danger" onClick={this.deleteUnit}>Delete Unit</button>
      pageHeader = <h3>{"Edit Unit  " + unit.primary_unit}</h3>
    }
    else {
      pageHeader =  <h3 >Create New Unit</h3>
    }

    return (
      <div>
      <section className="medium">
            {pageHeader}
            <ul className="list-inline">

              <li className="pull-right">{deleteUnitBtn}</li>
            </ul>
      </section>
          <div className="">
              <div className="row">
                <div className="col-sm-12">
                <div className="form-group">
                  <label htmlFor="primary_unit_code">Primary Unit Code (Max 3 chars)</label>
                    <input type="text" name="primary_unit_code" className="form-control" placeholder="" maxLength="3"
                       onChange={this.handleInputChange} value={unit.primary_unit_code} />
                       <span className="text-danger">{primary_unit_code}</span>
                </div>

                    <div className="form-group">
                      <label htmlFor="primary_unit">Primary Unit</label>

                        <input type="text" name="primary_unit" className="form-control"
                           onChange={this.handleInputChange} value={unit.primary_unit} />

                    </div>

                    <div className="form-group">

                    <div className="row">
                    <div className="col-xs-6">
                      <label htmlFor="container_unit">Container Unit (Optional)</label>
                    </div>
                    <div className="col-xs-6">
                      <label htmlFor="container_unit_plural">Plural</label>
                    </div>
                    </div>
                      <div className="row">
                        <div className="col-xs-6">
                        <input type="text" name="container_unit" className="form-control"
                          onChange={this.handleContainerChange} value={unit.container_unit} />
                        </div>
                        <div className="col-xs-6">
                        <input type="text" name="container_unit_plural" className="form-control" placeholder="plural form"
                          onChange={this.handleInputChange} value={unit.container_unit_plural} />
                        </div>
                      </div>




                    </div>
                    <div className="form-group">
                      {containerForm}
                    </div>

                    <span className="text-danger">{primary_unit_error}{container_unit_error}{container_volume_error}</span>
                    <div className="form-group">
                      <input type="submit" className="btn btn-info btn-block" value="Submit" onClick={this.addunit}/>
                    </div>

                </div>
              </div>
          </div>


      </div>
    )
  }
}

export default AddUnit



// WEBPACK FOOTER //
// ./src/components/unit/addunit.js